import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ParticipantHeader = _resolveComponent("ParticipantHeader")!
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_SingleErrorMessage = _resolveComponent("SingleErrorMessage")!
  const _component_ValidationAlert = _resolveComponent("ValidationAlert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.headerData && !_ctx.errorMessage)
      ? (_openBlock(), _createBlock(_component_ParticipantHeader, {
          key: 0,
          data: _ctx.headerData
        }, null, 8, ["data"]))
      : _createCommentVNode("", true),
    _createVNode(_component_PageHeader, { headerText: "Judicial History" }),
    (_ctx.isLoading && !_ctx.errorMessage)
      ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_component_SingleErrorMessage, { errorMessage: _ctx.errorMessage }, null, 8, ["errorMessage"]),
    _createVNode(_component_ValidationAlert, { validationResults: _ctx.validationMessages }, null, 8, ["validationResults"]),
    (!_ctx.isLoading && !_ctx.errorMessage)
      ? (_openBlock(), _createBlock(_component_v_card, { key: 2 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_data_table, {
                          headers: _ctx.criminalHistoryOptionsHeaders,
                          items: _ctx.criminalHistories,
                          class: "elevation-1"
                        }, {
                          "item.caseNumber": _withCtx(({ item }) => [
                            _createVNode(_component_v_text_field, {
                              modelValue: item.caseNumber,
                              "onUpdate:modelValue": ($event: any) => ((item.caseNumber) = $event),
                              readonly: !_ctx.canEditRolePermission
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
                          ]),
                          "item.arrestDate": _withCtx(({ item }) => [
                            _createVNode(_component_v_text_field, {
                              type: "date",
                              modelValue: item.arrestDate,
                              "onUpdate:modelValue": ($event: any) => ((item.arrestDate) = $event),
                              readonly: !_ctx.canEditRolePermission
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
                          ]),
                          "item.chargeType": _withCtx(({ item }) => [
                            _createVNode(_component_v_select, {
                              items: _ctx.chargeTypeSelectItems,
                              clearable: "",
                              "item-value": "id",
                              "item-title": "description",
                              modelValue: item.chargeTypeId,
                              "onUpdate:modelValue": ($event: any) => ((item.chargeTypeId) = $event),
                              readonly: !_ctx.canEditRolePermission
                            }, {
                              selection: _withCtx(({ item }) => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.getAbbreviatedText(item.title)), 1)
                              ]),
                              _: 2
                            }, 1032, ["items", "modelValue", "onUpdate:modelValue", "readonly"])
                          ]),
                          "item.arrestCharge": _withCtx(({ item }) => [
                            _createVNode(_component_v_select, {
                              items: _ctx.chargeTypeSelectItems,
                              clearable: "",
                              "item-value": "id",
                              "item-title": "description",
                              modelValue: item.arrestHistoryId,
                              "onUpdate:modelValue": ($event: any) => ((item.arrestHistoryId) = $event),
                              readonly: !_ctx.canEditRolePermission
                            }, {
                              selection: _withCtx(({ item }) => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.getAbbreviatedText(item.title)), 1)
                              ]),
                              _: 2
                            }, 1032, ["items", "modelValue", "onUpdate:modelValue", "readonly"])
                          ]),
                          "item.citation": _withCtx(({ item }) => [
                            _createVNode(_component_v_select, {
                              items: _ctx.chargeTypeSelectItems,
                              clearable: "",
                              "item-value": "id",
                              "item-title": "description",
                              modelValue: item.citationId,
                              "onUpdate:modelValue": ($event: any) => ((item.citationId) = $event),
                              readonly: !_ctx.canEditRolePermission
                            }, {
                              selection: _withCtx(({ item }) => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.getAbbreviatedText(item.title)), 1)
                              ]),
                              _: 2
                            }, 1032, ["items", "modelValue", "onUpdate:modelValue", "readonly"])
                          ]),
                          "item.drugOrAlcoholRelated": _withCtx(({ item }) => [
                            _createVNode(_component_v_select, {
                              items: _ctx.drugOrAlcoholSelectItems,
                              "item-value": "id",
                              "item-title": "description",
                              modelValue: item.drugOrAlcoholRelatedId,
                              "onUpdate:modelValue": ($event: any) => ((item.drugOrAlcoholRelatedId) = $event),
                              readonly: !_ctx.canEditRolePermission
                            }, null, 8, ["items", "modelValue", "onUpdate:modelValue", "readonly"])
                          ]),
                          "item.bac": _withCtx(({ item }) => [
                            _createVNode(_component_v_text_field, {
                              type: "number",
                              modelValue: item.bac,
                              "onUpdate:modelValue": ($event: any) => ((item.bac) = $event),
                              readonly: !_ctx.canEditRolePermission
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
                          ]),
                          "item.degree": _withCtx(({ item }) => [
                            _createVNode(_component_v_select, {
                              items: _ctx.degreeSelectItems,
                              "item-value": "id",
                              "item-title": "description",
                              modelValue: item.degreeId,
                              "onUpdate:modelValue": ($event: any) => ((item.degreeId) = $event),
                              readonly: !_ctx.canEditRolePermission
                            }, null, 8, ["items", "modelValue", "onUpdate:modelValue", "readonly"])
                          ]),
                          "item.actions": _withCtx(({ item, index }) => [
                            (_ctx.canEditRolePermission)
                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.removeCriminalHistory(item.participantCriminalHistoryId, index)),
                                  density: "comfortable",
                                  size: "small",
                                  icon: "mdi-delete",
                                  color: "info"
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ma-1" }, null, -1))
                          ]),
                          _: 1
                        }, 8, ["headers", "items"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        (_ctx.canEditRolePermission)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addCriminalHistory())),
                              color: "info"
                            }, {
                              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                _createTextVNode(" Add New ", -1)
                              ]))]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { align: "center" }, {
                      default: _withCtx(() => [
                        (_ctx.canEditRolePermission)
                          ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              class: "mx-2 mb-4",
                              color: "success",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveCriminalHistories())),
                              disabled: _ctx.isLoading
                            }, {
                              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                _createTextVNode("Save", -1)
                              ]))]),
                              _: 1
                            }, 8, ["disabled"])), [
                              [_directive_ripple]
                            ])
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}